import * as ModalConstants from "../constants/modal.constant";

const initialState = {
  modalType: "",
  modalData: "",
  modalActionLoading: false,
};

const modalReducer = (state = initialState, action) => {
  switch (action.type) {
    case ModalConstants.SHOW_MODAL:
      return {
        ...state,
        modalType: action.payload.type,
        modalData: action.payload.data,
      };
    case ModalConstants.HIDE_MODAL:
      return { ...state, modalType: undefined, modalData: {} };
    case ModalConstants.MODAL_ACTION_LOADING:
      return { ...state, modalActionLoading: true };
    default:
      return state;
  }
};

export default modalReducer;
